import { keyframes } from 'styled-components';

/**
 * Signature ОСНОВА animations.
 *
 * The brand metaphor is "foundation / основа" — animations should feel like
 * blocks being laid into place: a confident drop, a brief settle, then quiet.
 * Keep them subtle. They should never delay user input.
 */

// Each brand letter falls into place from above.
export const blockDrop = keyframes`
  0%   { opacity: 0; transform: translateY(-14px) scaleY(0.6); }
  60%  { opacity: 1; transform: translateY(2px)   scaleY(1.04); }
  100% { opacity: 1; transform: translateY(0)     scaleY(1); }
`;

// Page-level reveal — slight rise + fade.
export const riseIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// Used in modals and dropdowns.
export const popIn = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
`;

// Construction-tape stripes scrolling for progress.
export const stripeScroll = keyframes`
  from { background-position: 0 0; }
  to   { background-position: 32px 0; }
`;

// Spinner that draws and erases — a quiet pulse, not a noisy spin.
export const pulse = keyframes`
  0%, 100% { opacity: 0.55; transform: scale(1); }
  50%      { opacity: 1;    transform: scale(1.08); }
`;

// Soft underline that slides into place under active tab.
export const slideIn = keyframes`
  from { transform: scaleX(0); }
  to   { transform: scaleX(1); }
`;

// Subtle shimmer for loading skeletons.
export const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;
